export const APPID = {
  WETV: 'wetv',
  IFLIX: 'iflix',
};

export const KEY_NAME = {
  DOWN: 'down',
  UP: 'up',
  LEFT: 'left',
  RIGHT: 'right',
};

export const DEFN_LOCAL_KEY = 'definition';

export const ONELINK_URL = {
  iflix: 'https://iflix.onelink.me/IFpb?pid=uncolorcloud&type=1&af_force_deeplink=true&af_dp=iflix://iflix.com/login',
  tv: 'https://qqlivei18n.onelink.me/ETTr?pid=uncolorcloud&type=1&af_force_deeplink=true&af_dp=tenvideoi18n://wetv/login',
  tvdtv: 'https://qqlivei18n.onelink.me/nyiU/igxqfpyw?pid=uncolorcloud&type=1&af_force_deeplink=true&af_dp=tenvideoi18n://wetv/login',
};

export const subtitleTypeData = [
  { name: '语言', id: 0 },
  { name: '字体大小', id: 1 },
];

export const subtitleFontsizeData = [
  { name: 'small', id: 0, fontSize: 19.6, renderFontSize: 38.5, size: 0.7 },
  { name: 'middle', id: 1, fontSize: 25.2, renderFontSize: 49.5, size: 0.9 },
  { name: 'large', id: 2, fontSize: 30.8, renderFontSize: 60.5, size: 1.1 },
  { name: 'larger', id: 3, fontSize: 36.4, renderFontSize: 71.5, size: 1.3 },
  { name: 'largest', id: 4, fontSize: 39.2, renderFontSize: 77, size: 1.4 },
];

export const userInfoEnum = {
  VISITOR: '1',
  NO_VIP_USER: '2',
  VIP_USER: '3',
};

export const vplatformInfo = {
  wetv: '8',
  iflix: '8',
  tvdtv: '8',
};

export const videoAppidInfo = {
  wetv: '1200012',
  iflix: '1200016',
  tvdtv: '1200012',
};

export const PTInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
  tvdtv: 'WETVLINUX',
};

export const TVKPlatformInfo = {
  wetv: '3580601',
  iflix: '3610601',
  tvdtv: '8040601',
};

export const ORIPTInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
  tvdtv: 'WETVLINUX',
};

export const licenceInfo = {
  wetv: 'WETVLINUX',
  iflix: 'IFLIXLINUX',
  tvdtv: 'WETVLINUX',
};

export const prodLineKeyToPlayPlatformKey = {
  wetv: 'tv',
  iflix: 'tv',
  tvdtv: 'tv_dtv',
};

export const defaultLangCode = '1491988';

export const langIdToLangName = {
  1491988: 'en',
  1491973: 'th',
  1491937: 'id',
  8229847: 'zh-tw',
  1491963: 'zh-cn',
  40: 'ms',
  8: 'ja',
  9: 'ko',
  12: 'pt',
  14: 'es',
  54: 'ar',
  1491994: 'vi',
};

export const LGVChannelID = ['16566', '16567', '16629'];

export const PlatEnum = {
  IFLIX: 'iflix',
  WETV: 'wetv',
  TENCENTVIDEO: 'tvdtv',
};
